import * as React from "react";
import Layout from "layout";
import Routers from "./Routers";
import BarVertical from "components/BarVertical";
import MenuItemsModule from "components/MenuItemsModule";
import { useTranslation } from "react-i18next";
import ErrorBoundary from "error/ErrorBoundary";

const Catalog = ({ childrenMenu = [] }) => {
  const [t] = useTranslation("global");
  const [filter, setFilter] = React.useState([]);
  
  React.useEffect(() => {
    setFilter(childrenMenu);
  }, [childrenMenu])

  return (
    <Layout iconName={"catalog"} textRoute={t("modules.title_catalogs")}>
      <div className="mt-10 grid grid-cols-20/80 gap-x-2 min-h-[450px] pr-2">
        <BarVertical title={t("modules.title_catalogs")}>
          <ErrorBoundary>
            <MenuItemsModule items={filter} />
          </ErrorBoundary>
        </BarVertical>
        <div className="overflow-x-hidden">
          <ErrorBoundary>
            <Routers views={childrenMenu} />
          </ErrorBoundary>
        </div>
      </div>
    </Layout>
  );
};

export default Catalog;
